import api from "./axiosInstance";

/**
 * Reports API Service
 * Handles all report related API calls
 */

export const reportsApi = {
  /**
   * Get Product Wise Report
   * GET /api/v1/reports/products?fromDate=2026-06-01&toDate=2026-06-30
   * OR GET /api/v1/reports/products?period=WEEKLY|MONTHLY
   */
  getProductWiseReport: (params = {}) => {
    return api.get("reports/products", { params });
  },

  /**
   * Get Product Wise Inventory Report
   * GET /api/v1/reports/products/inventory?productName=Oxygen 47L&fromDate=2026-06-01&toDate=2026-06-30
   * OR GET /api/v1/reports/products/inventory?productName=Oxygen 47L&period=WEEKLY|MONTHLY
   */
  getProductInventoryReport: (params = {}) => {
    return api.get("reports/products/inventory", { params });
  }
};

export default reportsApi;
